"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function removeUndefinedEntries(object) {
    return Object.keys(object).reduce((acc, key) => object[key] !== undefined ? Object.assign(Object.assign({}, acc), { [key]: object[key] }) : acc, {});
}
exports.default = removeUndefinedEntries;
